export function validateEmail(val) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(val).toLowerCase())
}

export function formattedPhoneNumber(val) {
    if (/^[+\d][\d\s-]*$/.test(val)) {
        const cleanedVal = val.replace(/\D/g, ''); //remove non-digit characters 

        let formattedVal = ''
        if (cleanedVal.startsWith('46')) { //if 46 then add +
            formattedVal = `+${cleanedVal}`
        } else if (cleanedVal.startsWith('00')) { //if 0046 remove 00
            formattedVal = `+${cleanedVal.replace(/^00+/, '')}`
        } else if (cleanedVal.startsWith('0')) { //if 072 remove 0 add +46
            formattedVal= `+46${cleanedVal.replace(/^0/, '')}`
        } else if (cleanedVal.startsWith('+')) { //starts with +46
            formattedVal = cleanedVal
        } else if (!cleanedVal.startsWith('+46') && !cleanedVal.startsWith('+')) { //test with +25 phone number (eg: 250 && 07)
            formattedVal=`+46${cleanedVal}`
        }
        // result will be eg: '+46711531055'
        return formattedVal;
    }
    return false; //if not a valid number
}

export function detectIosInAppBrowser() {
    const userAgent = navigator.userAgent || "";
    const normalizedUserAgent = userAgent.toLowerCase();
    const isLegacyIOSDevice = /iphone|ipad|ipod/.test(normalizedUserAgent);
    const isIPadOSDesktopMode = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    const isIOSDevice = isLegacyIOSDevice || isIPadOSDesktopMode;
    const isInAppBrowser = /fban|fbav|fb_iab|fbios|fb4a|instagram|messengerforios|messenger/.test(normalizedUserAgent);
    return {
      isIosInAppBrowser: isIOSDevice && isInAppBrowser,
      isIOSDevice,
      isInAppBrowser,
      userAgent,
    };
  }